import ITextValue from 'types/textValue';

export const LroiDateIntervalOptions: ITextValue[] = [
  {
    text: 'Auto',
    value: '',
  },
  {
    text: 'Day',
    value: 'DAY',
  },
  {
    text: 'Week',
    value: 'WEEK',
  },
  {
    text: 'Month',
    value: 'MONTH',
  },
];
